<template>
    <div class="error404">
        <div class="page-404-content">
            <div class="container">
                <div class="row  full-height">
                    <div class="col-md-12 text-center">
                        <div class="error-image section-space--mb_50">
                            <img class="img-fluid" src="https://firebasestorage.googleapis.com/v0/b/mining-israa-group.appspot.com/o/website%2F404-img%2Fpage-404-image.png?alt=media&token=a02ef20b-ba5e-4350-bd52-cfe21243a113" alt="Not Found Image">
                        </div>
                        <h1 class="error-404-title font-weight--light text-white"> {{handleTranslate("title")}}</h1>
                        <div class="error-buttons section-space--mt_50">
                            <router-link class="ht-btn ht-btn-md" to="/">
                                 <span class="button-icon mr-2">
                                    <i class="fa fa-home"></i>
                                </span>
                                <span class="button-text">{{handleTranslate("btn")}}</span>
                            </router-link>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'NotFound',
          methods:{
        i18n(key, args) {
      return this.$t(key, args);
    },
    handleTranslate(type){
        if(type.includes('title'))
        return this.i18n('notFound.title');
        if(type.includes('btn'))
        return this.i18n('notFound.btn');

    }
    
  }
    }
</script>